import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, IconButton, styled } from '@mui/material'
import React from 'react'
import { Close as CloseIcon } from '@mui/icons-material';
import { translate } from '../../helper';
import CustomSpinner from '../CustomSpinner';
import { resolveCssVarValue } from '../../utils/CommonFunction';

const StyledDialog = styled(Dialog)(({ theme,loading }) => ({
  '.MuiDialog-container': {
    '.MuiPaper-root': {
      'minHeight': 'auto !important',
    }
  },
  '.MuiDialogTitle-root': {
    'backgroundColor': '#F8B218',
    'color': '#fff',
  },
  '.MuiDialogContent-root': {
    'padding': 'calc(var(--sp-lg)*2) var(--sp-lg) calc(var(--sp-lg)*2)',
    'h5': {
      'fontWeight': '700',
      'fontSize': 'calc(var(--fs-xl)*1.13207)',
      'marginBottom': 'var(--sp-lg)',
      'textAlign': 'center',
      'color': '#000',
    },
    'p': {
      'fontSize': 'var(--fs-xl)',
      'color': '#000',
      'textAlign': 'center',
      '&:not(:last-child)': {
        'marginBottom': 'var(--sp-lg)',
      }
    }
  },
  '.MuiDialogActions-root': {
    'justify-content': 'center',
    'padding-bottom': 'calc(var(--sp-lg)*2.359)',
    'button': {
      'fontSize': 'var(--fs-body)',
      'padding': 'var(--sp-md) calc(var(--sp-lg)*2.8301)',
      'borderRadius': 'var(--sp-md2)',
      'textTransform': 'capitalize',
      'boxShadow': 'none',
      '&:first-child': {
        'background': loading ? '#f7efef' : '#F8B218'
      },
      '&:not(:first-child)': {
        'marginLeft': 'calc(var(--sp-md2)*2.358)',
        'border': '1px solid #6B7280',
        'color': '#6B7280',
      }
    }
  }
}));

const ConfirmDialog = ({ isOpen, onClose, title, description, descriptionbold, onOk, loading=false }) => {
  return (
    <StyledDialog componentsProps={{ backdrop: { style: { backgroundColor: "rgb(0,0,0,0.7)" } } }} maxWidth="calc(var(--fs-hero)*14.15)" open={isOpen} onClose={onClose} loading={loading}>
      <div className='dialogcustom'>
        <DialogTitle sx={{fontSize:'calc(var(--fs-xs)*1.9)'}}>{translate(title)}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#fff',
          }}
        >
          <CloseIcon sx={{fontSize: 'calc(var(--fs-sm)*2)'}} />
        </IconButton>
        <DialogContent sx={{ textAlign: 'center' }}>
          {descriptionbold && (
            <div style={{ fontWeight: 600, marginBottom: 8, fontSize: 'calc(var(--fs-xl))' }}>
              {translate(descriptionbold)}
            </div>
          )}
          <DialogContentText>
            {translate(description)}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={onOk} disabled={loading}>{loading ? <CustomSpinner size={resolveCssVarValue('--fs-xl')*1.32075}/> :translate('yes')}</Button>
          <Button variant="outlined" onClick={onClose}>{translate('no')}</Button>
        </DialogActions>
      </div>
    </StyledDialog>
  )
}

export default ConfirmDialog
